export default __webpack_public_path__ + "static/media/logowhite.992f533e.png";